module.exports = __webpack_public_path__ + "img/dimsum-3.303f5db4.jpg";